import { render, staticRenderFns } from "./anchor_list.vue?vue&type=template&id=3a1ae946&scoped=true"
import script from "./anchor_list.vue?vue&type=script&lang=js"
export * from "./anchor_list.vue?vue&type=script&lang=js"
import style0 from "./anchor_list.vue?vue&type=style&index=0&id=3a1ae946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1ae946",
  null
  
)

export default component.exports